import Validations from "@pages/gestionConge/Validations/Validations";
import { BASE_URL } from "config/config";
import React, { useEffect, useState } from "react";
import { Table, Row, Col, Form, Button, Modal, Badge } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  useGetCRAByIdQuery,
  useValidateCRAMutation,
  useRefuseCRAMutation,
} from "store/cra/cra.api";

const ConsultCra = () => {
  const { craId } = useParams();

  const { data: craData, isLoading, isError } = useGetCRAByIdQuery(craId);
  console.log(craData);
  const [validateCRA] = useValidateCRAMutation();
  const [refuseCRA] = useRefuseCRAMutation();
  const currentUser = useSelector((state) => state.auth.user);
  const [daysInMonth, setDaysInMonth] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [reason, setReason] = useState("");

  const weekDays = ["DI", "LU", "MA", "ME", "JE", "VE", "SA"];

  useEffect(() => {
    if (!craData?.data?.data) return;

    const days = [];
    const date = new Date(
      craData.data.data.year,
      craData.data.data.month - 1,
      1
    );
    while (date.getMonth() === craData.data.data.month - 1) {
      days.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    setDaysInMonth(days);

    const fetchHolidays = async () => {
      try {
        const res = await fetch(
          `https://date.nager.at/api/v3/PublicHolidays/${craData.data.data.year}/FR`
        );
        const data = await res.json();
        setHolidays(data.map((h) => new Date(h.date).toDateString()));
      } catch (err) {
        console.error(err);
      }
    };
    fetchHolidays();
  }, [craData?.data?.data]);

  if (isLoading) return <div>Chargement...</div>;
  if (isError || !craData?.data?.data)
    return <div>Erreur lors du chargement du CRA</div>;

  const cra = craData.data.data;
  const lineData = cra.lines || {};
  const totalPerDay = {};

  daysInMonth.forEach((day) => {
    const dayStr = day.toLocaleDateString("fr-CA");
    const isWeekend = day.getDay() === 0 || day.getDay() === 6;
    const isHoliday = holidays.includes(day.toDateString());
    totalPerDay[dayStr] =
      isWeekend || isHoliday
        ? 1
        : Object.values(lineData).reduce(
            (sum, line) => sum + (Number(line[dayStr]) || 0),
            0
          );
  });
  const cra1 = craData?.data?.data;

  const steps = [
    {
      name: currentUser.name,
      date: cra1?.createdAt ? new Date(cra1.createdAt) : null,
      signed: true,
    },
    {
      name: cra1?.validateur?.name,
      date:
        cra1?.status === "validated" && cra1?.updatedAt
          ? new Date(cra.updatedAt)
          : null,
      signed: cra1?.status === "validated",
    },
  ];
  const grandTotal = Object.values(totalPerDay).reduce((sum, v) => sum + v, 0);

  const getStatusBadge = (status) => {
    switch (status) {
      case "draft":
        return <Badge bg="secondary">Brouillon</Badge>;
      case "pending_validation":
        return <Badge bg="warning">En attente de validation</Badge>;
      case "validated":
        return <Badge bg="success">Validé</Badge>;
      case "refused":
        return <Badge bg="danger">Refusé</Badge>;
      default:
        return <Badge bg="dark">Inconnu</Badge>;
    }
  };
  function getImageURL(id) {
    return `${BASE_URL}cra/${id}/image`;
  }
  return (
    <div className="timesheet-container p-3 m-4">
      <h5>
        CRA de {cra.collaborator.name} - {cra.month}/{cra.year}{" "}
        {getStatusBadge(cra.status)}
      </h5>

      {/* Tableau du CRA */}
      <Table bordered hover responsive className="timesheet-table mb-3">
        <thead>
          <tr>
            <th>Jour</th>
            {daysInMonth.map((day) => (
              <th key={day.toDateString()}>
                <div>{weekDays[day.getDay()]}</div>
                <div>{day.getDate()}</div>
              </th>
            ))}
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(lineData).map((lineKey) => (
            <tr key={lineKey}>
              <td>{lineKey}</td>
              {daysInMonth.map((day) => {
                const dayStr = day.toLocaleDateString("fr-CA");
                const isWeekend = day.getDay() === 0 || day.getDay() === 6;
                const isHoliday = holidays.includes(day.toDateString());
                return (
                  <td
                    key={dayStr}
                    className={isWeekend || isHoliday ? "weekend-cell" : ""}>
                    <Form.Control
                      type="text"
                      value={lineData[lineKey][dayStr] || ""}
                      disabled
                    />
                  </td>
                );
              })}
              <td>
                {Object.values(lineData[lineKey]).reduce(
                  (sum, v) => sum + (Number(v) || 0),
                  0
                )}
                j
              </td>
            </tr>
          ))}
          <tr className="fw-bold">
            <td>Total</td>
            {daysInMonth.map((day) => {
              const dayStr = day.toLocaleDateString("fr-CA");
              return <td key={dayStr}>{totalPerDay[dayStr]}j</td>;
            })}
            <td>{grandTotal}j</td>
          </tr>
        </tbody>
      </Table>

      {/* Commentaire et pièces jointes */}
      <Row className="mt-4">
        <Col md={6}>
          <h6>Commentaires</h6>
          <p>{cra.commentaire || "Aucun commentaire fourni."}</p>
        </Col>
        <Col md={6}>
          <h6>Pièces jointes</h6>
          {cra.attachments ? (
            <ul>
              <li>
                <a
                  href={getImageURL(cra?._id)}
                  target="_blank"
                  rel="noopener noreferrer">
                  {cra.attachments}
                </a>
              </li>
            </ul>
          ) : (
            <p>Aucune pièce jointe.</p>
          )}
        </Col>
      </Row>
      <div className="p-4">
        <Validations steps={steps} currentStep={2} />
      </div>
      {/* Actions */}

      {/* Modal refus */}
    </div>
  );
};

export default ConsultCra;
